var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFalt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Technology/folder/alt"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M30 50.0002H50M30 76.6668H50C59.3342 76.6668 64.0013 76.6668 67.5665 74.8503C70.7025 73.2524 73.2522 70.7027 74.8501 67.5667C76.6667 64.0015 76.6667 59.3344 76.6667 50.0002V30.0002C76.6667 20.666 76.6667 15.9988 74.8501 12.4337C73.2522 9.29762 70.7025 6.74794 67.5665 5.15005C64.0013 3.3335 59.3342 3.3335 50 3.3335H30C20.6658 3.3335 15.9987 3.3335 12.4335 5.15005C9.29747 6.74794 6.74779 9.29762 5.1499 12.4337C3.33334 15.9988 3.33334 20.666 3.33334 30.0002V50.0002C3.33334 59.3344 3.33334 64.0015 5.1499 67.5667C6.74779 70.7027 9.29747 73.2524 12.4335 74.8503C15.9987 76.6668 20.6658 76.6668 30 76.6668ZM27.3333 63.3335H52.6667C56.4004 63.3335 58.2672 63.3335 59.6933 62.6069C60.9477 61.9677 61.9676 60.9478 62.6067 59.6934C63.3333 58.2674 63.3333 56.4005 63.3333 52.6668V47.3335C63.3333 43.5998 63.3333 41.733 62.6067 40.3069C61.9676 39.0525 60.9477 38.0326 59.6933 37.3934C58.2672 36.6668 56.4004 36.6668 52.6667 36.6668H27.3333C23.5997 36.6668 21.7328 36.6668 20.3067 37.3934C19.0523 38.0326 18.0325 39.0525 17.3933 40.3069C16.6667 41.733 16.6667 43.5998 16.6667 47.3335V52.6668C16.6667 56.4005 16.6667 58.2674 17.3933 59.6934C18.0325 60.9478 19.0523 61.9677 20.3067 62.6069C21.7328 63.3335 23.5997 63.3335 27.3333 63.3335Z",
    stroke: "#C1C3C7",
    strokeWidth: 4,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalt);
export default __webpack_public_path__ + "static/media/falt.3c3441ae5bb3eef83fc7a1a0d38fa1f9.svg";
export { ForwardRef as ReactComponent };